<template>
	<div class="c-chart-list">
		<draggable :ref="'chart-list-wrapper'" v-model="charts" :move="onMove" @end="onEnd" :options="{forceFallback: true, animation: 150}">
			<c-chart-list-item
			v-for="chart in charts"
			:ref="($route.params.chartid == chart.id ? 'active-chart' : 'chart')"
			:key="chart.id"
			:child="child"
			:parentid="parentid"
			:data="chart"
			:data-id="chart.id">
			</c-chart-list-item>
		</draggable>
		<button v-if="canHaveChilds" @click="$store.commit('START_ADDCHART', parentid)" class="no-btn v-chart-preview st-chart-preview">
			<div class="st-chart-preview__img">
				<div class="st-chart-preview__wrap">
					<div class="st-chart-preview__alttext">
						<strong>{{ $t('new Slide') }}</strong>
					</div>
				</div>
			</div>
		</button>
	</div>
</template>
<script>


import CChartListItem from '@/components/p-editor/c-chart-list-item';

import help_chart from '@/helpers/chart';

export default {
	name: 'c-chart-list',

	methods: {
		onMove(evt) {

			if (evt.dragged && evt.dragged.classList.contains('fixed')){
		        return false;
		    }
			if (evt.related){
		        return !evt.related.classList.contains('fixed');
		    }
		},
		onEnd(ev){
			const id 		= parseInt(ev.item.getAttribute('data-id')),
				  payload 	= {
				  	  'id'		: id,
				  	  'position': ev.newIndex,
				  	  'event'	: ev
				  };

			this.$store.commit('UPDATE_CHART', payload);
		}
	},

	computed: {
		devmode(){
			return this.$store.getters.devmode;
		},
		isMaster(){
			return (this.$store.getters.active_presentation == 'master' ? true : false);
		},
	},

	mounted(){
		if(typeof this.$refs['active-chart'] !== 'undefined'){
			var pos = this.$refs['active-chart'][0].$el.offsetTop;
			this.$refs['chart-list-wrapper'].scrollTop = pos;
		}
		// chart-list-wrapper
		// active-chart
		// chart
	},

	data(){
		return {
			charts: [],
			drag: false
		};
	},

	created() {
		this.charts = this.data;
	},

	watch: {
		data(newData){
			this.charts = newData;
		}
	},

	updated() {
		this.charts = this.data;
	},

	props: {
		data: {
			type: Array,
			default(){
				return [];
			}
		},
		child: {
			type: Boolean,
			default: false
		},
		canHaveChilds: {
			type: Boolean,
			default: false
		},
		parentid: {
			type: Number,
			default: 0
		}
	},

	components: {
		CChartListItem
	},
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/p-editor/c-chart-list.vue